import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Styles from "./ActiveListingConnection.module.css";
import TermsConditionModal from "../../TermsConditionModal/TermsConditionModal";
import UploadDocModal from "../../UploadDocModal/UploadDocModal";
import ViewInjectionModal from "../../ViewInjectionModal/ViewInjectionModal";
import ViewDrawalModal from "../../ViewDrawalModal/ViewDrawalModal";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as ExpandMoreIcon } from "../../../../../assets/images/expandMoreIcon.svg";
import { ReactComponent as HistoryIcon } from "../../../../../assets/images/history.svg";
import { ReactComponent as VectorIcon } from "../../../../../assets/images/VectorIcon.svg";
import { ReactComponent as InfoOutlinedIcon } from "../../../../../assets/images/info.svg";
import { ReactComponent as Chat } from "../../../../../assets/images/Chat_icon.svg";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../../../commons/Accordion";
import ViewDoc from "../../ViewDoc/ViewDoc";
import UpdateLedger from "../../UpdateLedger/UpdateLedger";
import { ReactComponent as SquareIcon } from "../../../../../assets/images/squareIcon.svg";
import ConnectionHistory from "../../ConnectionHistory/ConnectionHistory";
import { terminateBankingListing } from "../../../../../Redux/Slices/bankingSlice";
import ChatApplication from "../../../../ChatApplication/ChatApplication";
import { CardLoader } from "../../../../../commons/CardLoader/CardLoader";
import NoDataPage from "../../../../Banking/NoDataPage/NoDataPage";
import { Tooltip } from "@mui/material";
import { connectionClose } from "../../../../../Services/ApiCalling/banking";
import ClosePopup from "../../../../../commons/PopupModal/BankingPopup/ClosePopup/ClosePopup";
import LedgerHistory from "../../LedgerHistory/LedgerHistory";
import { openBilateralChat } from "../../CreateEdit/helpers";

const ActiveListingConnection = ({
  data,
  onRefresh,
  onOngoingStatusDetected,
  isLoading = false,
}) => {
  const selfListingId = data[0]?.selfListing?.id;
  const [expanded, setExpanded] = useState(0);
  const [selectedConnection, setSelectedConnection] = useState(null);

  const [selectedCounterparty, setSelectedCounterparty] = useState(null);
  const [finalModal, setFinalModal] = useState(false);
  const [acceptedConnections, setAcceptedConnections] = useState([]);
  const [uploadModal, setUploadModal] = useState(false);
  const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
  const [selectedInjectionData, setSelectedInjectionData] = useState([]);
  const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
  const [selectedDrawalData, setSelectedDrawalData] = useState([]);
  const [modalViewOnly, setModalViewOnly] = useState(false);
  const [modalApprovalMode, setModalApprovalMode] = useState(false);

  const [viewDocModalOpen, setViewDocModalOpen] = useState(false);
  const [viewDocConnectionId, setViewDocConnectionId] = useState(null);

  const [updateLedgerModalOpen, setUpdateLedgerModalOpen] = useState(false);
  const [updateLedgerConnectionId, setUpdateLedgerConnectionId] =
    useState(null);

  const [ledgerModalOpen, setLedgerModalOpen] = useState(false);
  const [ledgerConnectionId, setLedgerConnectionId] = useState(null);

  const [connectionHistoryOpen, setConnectionHistoryOpen] = useState(false);
  const [historyConnectionId, setHistoryConnectionId] = useState(null);
  const [activeViewCounterparty, setActiveViewCounterparty] = useState(null);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatConnectionId, setChatConnectionId] = useState(null);
  const [chatName, setChatName] = useState("");
  const [isClosePopupOpen, setIsClosePopupOpen] = useState(false);
  const [selectedConnectionId, setSelectedConnectionId] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const handleOpenConnectionHistory = (selfListingId) => {
    setHistoryConnectionId(selfListingId);
    setConnectionHistoryOpen(true);
  };

  const handleCloseConnectionHistory = () => {
    setHistoryConnectionId(null);
    setConnectionHistoryOpen(false);
  };

  const handleOpenLedger = (connectionId, counterparty) => {
    setLedgerConnectionId(connectionId);
    setActiveViewCounterparty(counterparty);
    setLedgerModalOpen(true);
  };

  const handleCloseLedger = () => {
    setLedgerModalOpen(false);
    setLedgerConnectionId(null);
  };

  const handleCloseUpdateLedger = () => {
    setUpdateLedgerModalOpen(false);
    setUpdateLedgerConnectionId(null);
  };

  const handleOpenViewDoc = (connectionId, counterparty) => {
    setViewDocConnectionId(connectionId);
    setActiveViewCounterparty(counterparty);
    setViewDocModalOpen(true);
  };

  const handleCloseViewDoc = () => {
    setViewDocModalOpen(false);
    setViewDocConnectionId(null);
  };

  const handleViewInjection = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedInjectionData(slotData);
    setViewInjectionModalOpen(true);
  };

  const handleViewDrawal = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedDrawalData(slotData);
    setViewDrawalModalOpen(true);
  };

  const userData = useSelector((state) => state.persistedReducer);
  const userId = userData?.user?.user?.userId;

  const handleAccordionChange = (panelIndex) => {
    if (panelIndex === expanded) {
      setExpanded("");
    } else {
      setExpanded(panelIndex);
    }
  };

  const handleOpenModal = (
    connection,
    counterparty,
    { viewOnly = false, isApprovalMode = false } = {}
  ) => {
    setSelectedConnection(connection);
    setSelectedCounterparty(counterparty);
    setModalViewOnly(viewOnly);
    setModalApprovalMode(isApprovalMode);
    setFinalModal(true);
  };

  const handleCloseModal = () => setFinalModal(false);

  const handleAccepted = (id) => {
    setAcceptedConnections((prev) => [...prev, id]);
    handleCloseModal();
  };

  const handleDeclined = (id) => {
    setAcceptedConnections((prev) => [...prev, id]);
    handleCloseModal();
  };

  const handleUploadModalOpen = (connection, counterparty) => {
    if (!connection?.id && !counterparty?.connectionId) {
      alert("Cannot open modal: insufficient data.");
      return;
    }

    setSelectedConnection(connection);
    setSelectedCounterparty(counterparty);
    setUploadModal(true);
  };

  const handleUploadClose = () => {
    setUploadModal(false);
  };

  const handleAllDocsUploaded = () => {
    handleUploadClose();
  };

  const agreementStatus = selectedCounterparty?.agreementStatus || "";

  const finalAgreementFile = {
    name: selectedConnection?.agreementDocumentName || "",
    url: selectedConnection?.agreementDocumentUrl || "",
  };
  const parseDMY = (str) => {
    if (!str) return null;
    const datePart = String(str).trim().split(" ")[0];
    const [dd, mmm, yyyy] = datePart.split("-");
    const months = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11,
      JAN: 0,
      FEB: 1,
      MAR: 2,
      APR: 3,
      MAY: 4,
      JUN: 5,
      JUL: 6,
      AUG: 7,
      SEP: 8,
      OCT: 9,
      NOV: 10,
      DEC: 11,
    };
    const month = months[mmm];
    const day = parseInt(dd, 10);
    const year = parseInt(yyyy, 10);
    if (Number.isNaN(day) || Number.isNaN(year) || month == null) return null;
    return new Date(year, month, day);
  };

  const slotDrawlsEndDate = useSelector(
    (state) =>
      state?.bankingSlice?.activeLedgerData[0]?.counterPartyListings[0]
        ?.finalizedConnectionValues?.slotDrawls[0]?.dateEndAt
  );

  const slotInjectionEndDate = useSelector(
    (state) =>
      state?.bankingSlice?.activeLedgerData[0]?.counterPartyListings[0]
        ?.finalizedConnectionValues?.slotInjects[0]?.dateEndAt
  );

  const startOfDay = (d) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate());

  const addDays = (d, days) => {
    const x = new Date(d);
    x.setDate(x.getDate() + days);
    return x;
  };

  const getMaxEndDate = (counterParties) => {
    const injectDates = [];
    const drawalDates = [];

    counterParties.forEach((cp) => {
      cp?.finalizedConnectionValues?.slotInjects?.forEach((inject) => {
        if (inject?.dateEndAt) {
          injectDates.push(parseDMY(inject.dateEndAt));
        }
      });
      cp?.finalizedConnectionValues?.slotDrawls?.forEach((drawal) => {
        if (drawal?.dateEndAt) {
          drawalDates.push(parseDMY(drawal.dateEndAt));
        }
      });
    });

    const allDates = [...injectDates, ...drawalDates].filter(Boolean);
    if (allDates.length === 0) return null;
    return allDates.reduce((a, b) => (a > b ? a : b));
  };

  const maxEndDate = data[0]?.counterPartyListings
    ? getMaxEndDate(data[0].counterPartyListings)
    : null;

  const closeActiveDate = maxEndDate
    ? addDays(startOfDay(maxEndDate), 1)
    : null;

  const handleClose = (connectionId) => {
    if (!connectionId) return;

    connectionClose(connectionId)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error("Failed to close connection", error);
      });
  };

  const farthestEndDatePlusOne = (() => {
    const d1 = parseDMY(slotDrawlsEndDate);
    const d2 = parseDMY(slotInjectionEndDate);
    const dates = [d1, d2].filter(Boolean);
    if (dates.length === 0) return null;
    const maxEnd = dates.reduce((a, b) => (a > b ? a : b));
    return addDays(startOfDay(maxEnd), 1);
  })();

  const canShowClose = closeActiveDate
    ? startOfDay(new Date()) >= closeActiveDate
    : false;

  useEffect(() => {
    let foundOngoing = false;
    data.forEach((item) => {
      item.counterPartyListings?.forEach((counterparty) => {
        if (counterparty.connectionStatus === "ONGOING") {
          foundOngoing = true;
        }
      });
    });

    if (foundOngoing && onOngoingStatusDetected) {
      onOngoingStatusDetected();
    }
  }, [data, onOngoingStatusDetected]);

  const shouldShowAlreadyAcceptedMessage = (
    selectedConnection,
    selectedCounterparty
  ) => {
    if (
      !selectedConnection?.counterPartyListings ||
      !Array.isArray(selectedConnection.counterPartyListings)
    ) {
      return false;
    }
    return (
      selectedConnection.counterPartyListings.some(
        (cp) => cp.status === "TERMS_ACCEPTED" || cp.status === "COMPLETED"
      ) && selectedCounterparty?.status !== "ACTIVE"
    );
  };
  const formattedStatus = (status) => {
    if (!status) return "—";
    if (status === "COMPLETED") return "Ongoing";
    return status
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleOpenClosePopup = (connectionId) => {
    setSelectedConnectionId(connectionId);
    setIsClosePopupOpen(true);
  };

  const handleClosePopup = () => {
    setSelectedConnectionId(null);
    setIsClosePopupOpen(false);
  };

  const handleConfirmClose = async () => {
    setLoading(true);
    try {
      await connectionClose(selectedConnectionId);
      setLoading(false);
      setIsClosePopupOpen(false);
      window.location.reload();
    } catch (error) {
      setLoading(false);
      console.error("Failed to close connection", error);
    }
  };

  const handleChatOpen = (fromUser, toUser, initId) => {
    let chatId;

    if (fromUser === initId) {
      chatId = `${fromUser?.split("_")?.[0]}_${toUser?.split("_")?.[0]}`;
    } else {
      chatId = `${toUser?.split("_")?.[0]}_${fromUser?.split("_")?.[0]}`;
    }

    openBilateralChat(dispatch, {
      header: toUser,
      fromUser,
      toUser,
      chatId,
    });
  };

  return (
    <>
      {finalModal && (
        <TermsConditionModal
          activeData={selectedConnection}
          activeCounterparty={selectedCounterparty}
          open={finalModal}
          handleClose={handleCloseModal}
          connectionId={selectedConnection?.id}
          counterpartyId={selectedCounterparty?.id}
          onAccept={() => {
            handleAccepted(selectedCounterparty?.id);
            if (onRefresh) onRefresh();
          }}
          onDecline={() => {
            handleDeclined(selectedCounterparty?.id);
            if (onRefresh) onRefresh();
          }}
          termsData={data}
          viewOnly={modalViewOnly}
          isApprovalMode={modalApprovalMode}
          showAlreadyAcceptedMessage={shouldShowAlreadyAcceptedMessage(
            selectedConnection,
            selectedCounterparty
          )}
        />
      )}

      {uploadModal && (
        <UploadDocModal
          open={uploadModal}
          handleClose={() => {
            handleUploadClose();
            if (onRefresh) onRefresh();
          }}
          connectionId={
            selectedCounterparty?.connectionId || selectedConnection?.id
          }
          activeCounterparty={selectedCounterparty}
          onAllDocsUploaded={() => {
            handleAllDocsUploaded();
            if (onRefresh) onRefresh();
          }}
          upData={data}
          agreementStatus={agreementStatus}
          finalAgreementFile={finalAgreementFile}
          isCounterparty={
            !!selectedCounterparty?.agreementInitiatorId &&
            selectedCounterparty?.agreementInitiatorId !== userId
          }
          onRefresh={onRefresh}
        />
      )}

      {viewDocModalOpen && (
        <ViewDoc
          open={viewDocModalOpen}
          handleClose={handleCloseViewDoc}
          connectionId={viewDocConnectionId}
          viewDocData={data}
          activeCounterparty={activeViewCounterparty}
        />
      )}

      {ledgerModalOpen && (
        <LedgerHistory
          open={ledgerModalOpen}
          handleClose={handleCloseLedger}
          connectionId={ledgerConnectionId}
          viewDocData={data}
          activeCounterparty={activeViewCounterparty}
        />
      )}

      {viewInjectionModalOpen && (
        <ViewInjectionModal
          open={viewInjectionModalOpen}
          handleClose={() => setViewInjectionModalOpen(false)}
          data={selectedInjectionData}
        />
      )}

      {viewDrawalModalOpen && (
        <ViewDrawalModal
          open={viewDrawalModalOpen}
          handleClose={() => setViewDrawalModalOpen(false)}
          data={selectedDrawalData}
        />
      )}

      {updateLedgerModalOpen && (
        <UpdateLedger
          open={updateLedgerModalOpen}
          handleClose={() => {
            handleCloseUpdateLedger();
            if (onRefresh) onRefresh();
          }}
          connectionData={updateLedgerConnectionId}
          listingId={selfListingId}
          ongoingData={data}
          currentPage={1}
          itemsPerPage={10}
          totalCount={0}
          onPageChange={() => {}}
          onLedgerUpdated={() => {
            if (onRefresh) onRefresh();
          }}
        />
      )}

      {connectionHistoryOpen && (
        <ConnectionHistory
          connectionId={selfListingId}
          // listingId={selfListingId}
          open={connectionHistoryOpen}
          handleClose={handleCloseConnectionHistory}
        />
      )}

      <ClosePopup
        open={isClosePopupOpen}
        handleClose={handleClosePopup}
        onConfirm={handleConfirmClose}
        loading={loading}
      />

      <div>
        {data
          ?.filter((elem) => {
            const counterData = elem?.counterPartyListings;
            if (!counterData || counterData.length === 0) return false;

            return true;
          })
          .map((elem, index) => {
            let selfData = elem?.selfListing;
            let counterData = elem?.counterPartyListings;

            return (
              <>
                {/* <div key={index}>
                  <div
                    className={`display_flex_row_center ${Styles.listHeaderSection}`}
                  >
                    <div
                      className={`display_flex_row ${Styles.listHeaderCont}`}
                    >
                      <div style={{ paddingLeft: "10px" }}>
                        <span>Injection Range</span>
                        <span className="display_flex_row_center">
                          {selfData?.bankingSlotInjects?.[0]?.dateStartAt +
                            " to " +
                            selfData?.bankingSlotInjects?.[0]?.dateEndAt}
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewInjection(selfData?.bankingSlotInjects);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <SquareIcon
                              style={{
                                width: "10px",
                                height: "10px",
                                paddingLeft: "4px",
                              }}
                            />
                          </span>
                        </span>
                      </div>
                      <div>
                        <span>Drawal Range</span>
                        <span className="display_flex_row_center">
                          {selfData?.bankingSlotDrawls?.[0]?.dateStartAt +
                            " to " +
                            selfData?.bankingSlotDrawls?.[0]?.dateEndAt}

                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleViewDrawal(selfData?.bankingSlotDrawls);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <SquareIcon
                              style={{
                                width: "10px",
                                height: "10px",
                                paddingLeft: "4px",
                              }}
                            />
                          </span>
                        </span>
                      </div>
                      <div>
                        <span>Banking Factor</span>
                        <span> {selfData?.bankingFactor}</span>
                      </div>
                      <div style={{ paddingRight: "10px" }}>
                        <span>Settlement Rate</span>
                        <span>{selfData?.settlementRate}</span>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div
                  className={`display_flex_row_center ${Styles.activeListTableCont}`}
                >
                  <div className={Styles.activeListHead}>
                    <div
                      style={{
                        width: "18%",
                        paddingLeft: "30px",
                      }}
                    >
                      Name
                    </div>
                    <div style={{}}>Injection Range</div>
                    <div
                      style={{
                        width: "17%",
                        textAlign: "center",
                      }}
                    >
                      Drawal Range
                    </div>
                    <div>BF(%)</div>
                    <div
                      style={{
                        paddingRight: "2%",
                        textAlign: "center",
                      }}
                    >
                      SR(₹/kWh)
                    </div>
                    {/* <div
                      style={{
                        paddingRight: "2%",
                        textAlign: "center",
                      }}
                    >
                      Status
                    </div> */}
                  </div>
                  <Accordion
                    key={index}
                    expanded={expanded === index}
                    onChange={() => handleAccordionChange(index)}
                    className={Styles.activeAccordion}
                  >
                    <AccordionDetails>
                      {counterData.map((ele, index) => {
                        const activeListingUserId = selfData?.userId;
                        const counterpartyUserId = ele.userId;
                        const termsInitiatorId = ele?.termsInitiatorId;
                        const connectionIsTermsInitiated =
                          ele?.connectionStatus === "TERMS_INITIATED";
                        const loggedInUserId = userId;

                        const showApproveButton =
                          connectionIsTermsInitiated &&
                          termsInitiatorId &&
                          loggedInUserId !== termsInitiatorId &&
                          loggedInUserId !== counterpartyUserId;

                        const isTermsAccepted =
                          ele.connectionStatus === "TERMS_ACCEPTED";

                        const agreementInit =
                          ele?.agreementInitiatorId === loggedInUserId;
                        const viewDocs =
                          agreementInit && ele?.agreementStatus === "UPLOADED";

                        const approveDocs =
                          !agreementInit && ele?.agreementStatus === "UPLOADED";
                        const isFinalizedEmpty =
                          !ele.finalizedConnectionValues ||
                          (!ele.finalizedConnectionValues.bankingFactor &&
                            !ele.finalizedConnectionValues.settlementRate &&
                            (!ele.finalizedConnectionValues.slotDrawls ||
                              ele.finalizedConnectionValues.slotDrawls
                                .length === 0) &&
                            (!ele.finalizedConnectionValues.slotInjects ||
                              ele.finalizedConnectionValues.slotInjects
                                .length === 0));

                        return (
                          <div
                            className={`display_flex_row_center ${Styles.contentTableActive}`}
                          >
                            <div className={Styles.activeListContent}>
                              <div className={Styles.activeRowSection}>
                                <div
                                  style={{
                                    width: "24%",
                                    paddingLeft: "30px",
                                  }}
                                  className={`display_flex_column_gap_4 ${Styles.listingCont_Name}`}
                                >
                                  <div>{ele?.companyName}</div>
                                  <div>{ele?.name}</div>
                                </div>
                                <div
                                  className="display_flex_row_gap_8_only"
                                  style={{
                                    width: "20%",
                                    textAlign: "center",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  {ele?.bankingSlotInjects?.[0]?.dateStartAt +
                                    " to " +
                                    ele?.bankingSlotInjects?.[0]?.dateEndAt}

                                  <span
                                    onClick={() =>
                                      handleViewInjection(
                                        ele?.bankingSlotInjects
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <SquareIcon />
                                  </span>
                                </div>
                                <div
                                  className="display_flex_row_gap_8_only"
                                  style={{
                                    width: "19%",
                                    textAlign: "center",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  {ele?.bankingSlotDrawls?.[0]?.dateStartAt +
                                    " to " +
                                    ele?.bankingSlotDrawls?.[0]?.dateEndAt}

                                  <span
                                    onClick={() =>
                                      handleViewDrawal(ele?.bankingSlotDrawls)
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <SquareIcon />
                                  </span>
                                </div>
                                <div
                                  style={{
                                    textAlign: "center",
                                    paddingRight: "1%",
                                    width: "18%",
                                  }}
                                >
                                  {ele?.bankingFactor}
                                </div>
                                <div
                                  style={{
                                    width: "7%",
                                    paddingRight: "2%",
                                    textAlign: "center",
                                  }}
                                >
                                  {ele?.settlementRate}
                                </div>
                              </div>
                              <div>
                                {ele?.connectionStatus !== "AUTO_WITHDRAW" &&
                                  ele?.connectionStatus !== "TERMS_INITIATED" &&
                                  Object.keys(
                                    ele?.finalizedConnectionValues || {}
                                  ).length > 0 &&
                                  ele.connectionStatus !== "LEDGER" && (
                                    <div
                                      className={`${Styles.finalMainContainer}`}
                                    >
                                      {/* <div
                                        className={`display_flex_row ${Styles.detailFinalElement}`}
                                        style={{
                                          height: "35px",
                                        }}
                                      >
                                        <div
                                          style={{ width: "18%" }}
                                          className={`display_flex_column_gap_4 ${Styles.finalT_CText}`}
                                        >
                                          Final Terms and Condition
                                        </div>
                                        <div
                                          className="display_flex_row_gap_8_only"
                                          style={{
                                            width: "20%",
                                          }}
                                        >
                                          {ele?.finalizedConnectionValues
                                            ?.slotInjects?.[0]?.dateStartAt +
                                            " to " +
                                            ele?.finalizedConnectionValues
                                              ?.slotInjects?.[0]?.dateEndAt}

                                          <span
                                            onClick={() =>
                                              handleViewInjection(
                                                ele?.finalizedConnectionValues
                                                  ?.slotInjects
                                              )
                                            }
                                            style={{ cursor: "pointer" }}
                                          >
                                            <SquareIcon />
                                          </span>
                                        </div>
                                        <div
                                          className="display_flex_row_gap_8_only"
                                          style={{
                                            width: "20%",
                                          }}
                                        >
                                          {ele?.finalizedConnectionValues
                                            ?.slotDrawls?.[0]?.dateStartAt +
                                            " to " +
                                            ele?.finalizedConnectionValues
                                              ?.slotDrawls?.[0]?.dateEndAt}

                                          <span
                                            onClick={() =>
                                              handleViewDrawal(
                                                ele?.finalizedConnectionValues
                                                  ?.slotDrawls
                                              )
                                            }
                                            style={{ cursor: "pointer" }}
                                          >
                                            <SquareIcon />
                                          </span>
                                        </div>
                                        <div
                                          style={{
                                            width: "10%",
                                            textAlign: "left",
                                          }}
                                        >
                                          {
                                            ele?.finalizedConnectionValues
                                              ?.bankingFactor
                                          }
                                        </div>
                                        <div
                                          style={{
                                            width: "10%",
                                            textAlign: "left",
                                          }}
                                        >
                                          {
                                            ele?.finalizedConnectionValues
                                              ?.settlementRate
                                          }
                                        </div>
                                        <div
                                          style={{
                                            width: "12%",
                                          }}
                                        >
                                          {ele?.connectionStatus}-
                                        </div>
                                      </div> */}
                                      <div
                                        className={`display_flex_row ${Styles.connectionHeadSection}`}
                                      >
                                        <div
                                          className="display_flex_row"
                                          style={{ gap: "16px" }}
                                        >
                                          <div
                                            className={Styles.connHead}
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              handleOpenConnectionHistory(
                                                ele?.connectionId
                                              )
                                            }
                                          >
                                            <span
                                              style={{
                                                cursor: "pointer",
                                              }}
                                            >
                                              <HistoryIcon
                                                style={{
                                                  width: 14,
                                                  height: 14,
                                                }}
                                              />
                                            </span>
                                            Connection History
                                            <span>
                                              <VectorIcon
                                                style={{
                                                  width: 8,
                                                  height: 8,
                                                  paddingBottom: "10px",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </span>
                                          </div>
                                          {ele?.status === "PAST" && (
                                            <>
                                              <div
                                                className={Styles.viewSide}
                                                onClick={() =>
                                                  handleOpenModal(elem, ele, {
                                                    viewOnly: true,
                                                    isApprovalMode: false,
                                                  })
                                                }
                                              >
                                                View T&C
                                                <span>
                                                  <VectorIcon
                                                    style={{
                                                      width: 8,
                                                      height: 8,
                                                      cursor: "pointer",
                                                      paddingLeft: "5px",
                                                      paddingBottom: "10px",
                                                    }}
                                                  />
                                                </span>
                                              </div>
                                            </>
                                          )}
                                          {ele?.connectionStatus ===
                                            "TERMS_ACCEPTED" &&
                                            isTermsAccepted &&
                                            viewDocs && (
                                              <>
                                                <div
                                                  className={Styles.viewSide}
                                                  onClick={() =>
                                                    handleUploadModalOpen(
                                                      elem,
                                                      ele
                                                    )
                                                  }
                                                >
                                                  Edit Documents
                                                  <span>
                                                    <VectorIcon
                                                      style={{
                                                        width: 8,
                                                        height: 8,
                                                        cursor: "pointer",
                                                        paddingLeft: "5px",
                                                        paddingBottom: "10px",
                                                      }}
                                                    />
                                                  </span>
                                                </div>
                                              </>
                                            )}

                                          {ele?.status === "PAST" && (
                                            <>
                                              <div
                                                className={Styles.viewSide}
                                                onClick={() =>
                                                  handleOpenViewDoc(
                                                    ele?.connectionId,
                                                    ele
                                                  )
                                                }
                                              >
                                                View Doc
                                                <span>
                                                  <VectorIcon
                                                    style={{
                                                      width: 8,
                                                      height: 8,
                                                      paddingBottom: "10px",
                                                      cursor: "pointer",
                                                    }}
                                                  />
                                                </span>
                                              </div>
                                            </>
                                          )}
                                          {ele?.status === "PAST" && (
                                            <>
                                              <div
                                                className={Styles.viewSide}
                                                onClick={() =>
                                                  handleOpenLedger(
                                                    ele?.connectionId,
                                                    ele
                                                  )
                                                }
                                              >
                                                View Ledger
                                                <span>
                                                  <VectorIcon
                                                    style={{
                                                      width: 8,
                                                      height: 8,
                                                      paddingBottom: "10px",
                                                      cursor: "pointer",
                                                    }}
                                                  />
                                                </span>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                        <div
                                          className={`display_flex_row_gap_8 ${Styles.button_mainContainer}`}
                                        >
                                          {ele?.status === "PAST" ? (
                                            <div
                                              className={`display_flex_row_gap_8 ${Styles.button_mainContainer}`}
                                            >
                                              <div
                                                className={Styles.chatBtn}
                                                style={
                                                  true
                                                    ? { cursor: "pointer" }
                                                    : {}
                                                }
                                                onClick={
                                                  true
                                                    ? () =>
                                                        handleChatOpen(
                                                          selfData?.name,
                                                          ele?.name,
                                                          ele?.connectionInitiatorListingId
                                                        )
                                                    : undefined
                                                }
                                              >
                                                View Chat
                                              </div>
                                              {/* <div
                                                    className="activeButton_type_2"
                                                    onClick={() =>
                                                      handleOpenModal(
                                                        elem,
                                                        ele,
                                                        {
                                                          viewOnly: true,
                                                          isApprovalMode: false,
                                                        }
                                                      )
                                                    }
                                                  >
                                                    View T&C
                                                  </div>

                                                  <div
                                                    className="activeButton_type_2"
                                                    onClick={() =>
                                                      handleOpenViewDoc(
                                                        ele?.connectionId,
                                                        ele
                                                      )
                                                    }
                                                  >
                                                    View Doc
                                                  </div> */}

                                              {/* {canShowClose ? (
                                                <div
                                                  className="activeButton"
                                                  
                                                  onClick={() =>
                                                    handleOpenClosePopup(
                                                      ele.connectionId
                                                    )
                                                  }
                                                >
                                                  Close
                                                </div>
                                              ) : (
                                                <div
                                                  className={Styles.closeBtn}
                                                  style={{
                                                    cursor: "not-allowed",
                                                  }}
                                                >
                                                  Close
                                                </div>
                                              )} */}
                                            </div>
                                          ) : (
                                            <div
                                              className={`display_flex_row_gap_8 ${Styles.button_mainContainer}`}
                                            >
                                              <div
                                                className={Styles.chatBtn}
                                                style={
                                                  true
                                                    ? { cursor: "pointer" }
                                                    : {}
                                                }
                                                onClick={
                                                  true
                                                    ? () =>
                                                        handleChatOpen(
                                                          selfData?.name,
                                                          ele?.name,
                                                          ele?.connectionInitiatorListingId
                                                        )
                                                    : undefined
                                                }
                                              >
                                                View Chat
                                              </div>
                                              {viewDocs && (
                                                <div
                                                  className={
                                                    Styles.statusSideText
                                                  }
                                                >
                                                  {/* {formattedStatus(
                                                      ele?.connectionStatus
                                                    )} */}
                                                  Waiting Docs Approval
                                                </div>
                                              )}
                                              {/* <div
                                                    className="activeButton_type_2"
                                                    onClick={() =>
                                                      handleOpenModal(
                                                        elem,
                                                        ele,
                                                        {
                                                          viewOnly: true,
                                                          isApprovalMode: false,
                                                        }
                                                      )
                                                    }
                                                  >
                                                    View T&C
                                                  </div> */}
                                              {isTermsAccepted &&
                                                ele?.agreementStatus ===
                                                  "NOT_UPLOADED" && (
                                                  <div
                                                    className="activeButton"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      handleUploadModalOpen(
                                                        elem,
                                                        ele
                                                      );
                                                    }}
                                                  >
                                                    Documentation
                                                  </div>
                                                )}
                                              {viewDocs && (
                                                // <div
                                                //   className="activeButton"
                                                //   onClick={() =>
                                                //     handleUploadModalOpen(
                                                //       elem,
                                                //       ele
                                                //     )
                                                //   }
                                                // >
                                                //   Edit Documents
                                                // </div>
                                                // <div
                                                //   className={
                                                //     Styles.statusSideText
                                                //   }
                                                // >
                                                //   {formattedStatus(
                                                //     ele?.connectionStatus
                                                //   )}
                                                // </div>
                                                <div></div>
                                              )}
                                              {isTermsAccepted &&
                                                approveDocs && (
                                                  <div
                                                    className="activeButton"
                                                    onClick={() =>
                                                      handleUploadModalOpen(
                                                        elem,
                                                        ele
                                                      )
                                                    }
                                                  >
                                                    Accept Agreement
                                                  </div>
                                                )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </AccordionDetails>
                  </Accordion>
                </div>
              </>
            );
          })}
      </div>
    </>
  );
};

export default ActiveListingConnection;
